import React from 'react';
import './style.css';

interface LoadingAnimationProps {
  isLoading: boolean;
}

export const LoadingAnimation: React.FC<LoadingAnimationProps> = (props) => {
  const { isLoading } = props;

  return (
    <div
      className='loading-animation'
      style={{
        visibility: isLoading ? 'visible' : 'hidden',
        opacity: isLoading ? 1 : 0,
      }}
    >
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
